import { I18n } from '@calendly/i18n'
import { Badge } from '@calendly/ui/components/badge'

import { UserInfoAvatar } from 'features/user_profiles'

import {
  Email,
  TextWrapper,
  Title,
  Wrapper
} from './shared'
import { FullStoryExclude, FullStoryMask } from '../../shared/fullstory_privacy'

export const MigrationInfo = ({ migration, isAvatarNonInteractive = false }) => (
  <Wrapper>
    <FullStoryExclude>
      <UserInfoAvatar
        letter={migration.avatar_letter}
        name={migration.name}
        uuid={migration.organization_invitation_uuid}
        isNonInteractive={isAvatarNonInteractive}
        isPendingUser
      />
    </FullStoryExclude>
    <TextWrapper>
      <Title>
        <FullStoryMask>{migration.name}</FullStoryMask>
        <Badge spacingLeft="4">
          {I18n.t('publisher.organization.memberships_picker.pending_migration')}
        </Badge>
      </Title>
      <Email><FullStoryMask>{migration.email}</FullStoryMask></Email>
    </TextWrapper>
  </Wrapper>
)
